var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGraduate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11L19 6L10 1L1 6L10 11ZM10 11L16.1591 7.57826C16.7017 8.94659 17 10.4384 17 11.9999C17 12.7013 16.9398 13.3885 16.8244 14.0569C14.2143 14.3106 11.849 15.4006 10 17.0555C8.15096 15.4006 5.78571 14.3106 3.17562 14.0569C3.06017 13.3885 3 12.7012 3 11.9999C3 10.4384 3.29824 8.94656 3.84088 7.57825L10 11ZM6 16.9999V9.5L10 7.27778",
    stroke: "#545454",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraduate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/graduate.092b9d2b.svg";
export { ForwardRef as ReactComponent };